import type { KeyboardEvent, MouseEvent } from 'react';
import { Box, Image, Text } from '@chakra-ui/react';
import './styles.css';

export interface DesktopIconProps {
  id: string;
  label: string;
  iconSrc: string;
  selected: boolean;
  onSelect: (id: string) => void;
  onOpen: (id: string) => void;
}

/**
 * Classic desktop icon: single-click selects (border highlight),
 * double-click opens the associated window.
 */
export function DesktopIcon({ id, label, iconSrc, selected, onSelect, onOpen }: DesktopIconProps) {
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onSelect(id);
  };

  const handleDoubleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onOpen(id);
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onOpen(id);
    }
  };

  return (
    <Box
      className={['desktop-icon', selected ? 'desktop-icon--selected' : '']
        .filter(Boolean)
        .join(' ')}
      role="button"
      tabIndex={0}
      aria-label={label}
      aria-pressed={selected}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      onKeyDown={handleKeyDown}
    >
      <Image className="desktop-icon__image" src={iconSrc} alt="" draggable={false} />
      <Text className="desktop-icon__label">{label}</Text>
    </Box>
  );
}

export default DesktopIcon;
